import { Clear } from '@mui/icons-material'
import { FC, useState } from 'react'
import { MODAL_CONSTS } from '../../const/modal-const'
import AuthenticationModalLoginComponent from './authenticationModalComponent/AuthenticationModalLoginComponent'
import AuthenticationModalSignupComponent from './authenticationModalComponent/AuthenticationModalSignupComponent'

interface AuthenticationModalProps {
  handleModal?: any
  dataToPassOn: {
    onSaveAuth?: () => void
    eventId: string
  }
}

const AuthenticationModal: FC<AuthenticationModalProps> = ({ handleModal, dataToPassOn }) => {
  const [step] = useState<string>('login')

  const { onSaveAuth, eventId } = dataToPassOn

  const closeAuthModal = () => {
    handleModal(false, MODAL_CONSTS.AUTHENTICATION)
  }

  return (
    <>
      <div className="fixed left-0 right-0 top-0 bottom-0 z-10  transition-all visible">
        <div className="max-h-[463px] fixed bg-white px-4 pt-4 rounded-xl z-10 left-[calc(50%_-_1rem)] flex flex-col top-[calc(50%_-_1rem)] translate-x-[-50%] !translate-y-[-50%] w-[calc(100%_-_2rem)] max-w-md m-2 opacity-1 transition-all">
          <div className="max-h-screen min-h-[calc(100vh-200px)]">
            <div className="text-right">
              <button onClick={closeAuthModal}>
                {/* <img className='hover:bg-SeabiscuitDullMainThemeColor rounded-full p-1 w-7 h-7' src="/assets/cp_icons/Close.svg" /> */}
                <Clear
                  fontSize={'small'}
                  style={{
                    color: '#122B46',
                    fontWeight: '400',
                  }}
                />
              </button>
            </div>
            <h2 className="m-0 text-[25px] text-center text-SeabiscuitDark200ThemeColor font-bold">
              Log in to your account
            </h2>

            <div className="p-4">
              {step === 'login' ? (
                <AuthenticationModalLoginComponent
                  closeAuthModal={closeAuthModal}
                  handleModal={handleModal}
                  onSaveAuth={onSaveAuth}
                  eventId={eventId || ''}
                />
              ) : (
                <AuthenticationModalSignupComponent />
              )}
            </div>
          </div>
        </div>
        <div
          className={`fixed left-0 right-0 top-0 bottom-0 bg-black/30 opacity-1 transition-all`}
        ></div>
      </div>
    </>
  )
}

export default AuthenticationModal
